<template>
  <v-container fluid class="promotion-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-promotion`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Promotion
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-photo`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Photo
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-bundles`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            Bundle
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-discounts`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            Discounts
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-details`"
          >
            <v-icon class="mr-3">mdi-shape</v-icon>
            Details
          </v-tab>
          <v-tab-item
            :value="'tab-promotion'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Edit Promotion</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangePromotion($event, 'promotioncode')"
                        v-bind:value="initvalue.promotioncode"
                        placeholder="Promotion Code"
                        persistent-hint
                        single-line hint="Enter the promotion code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangePromotion($event, 'promotionname')"
                        v-bind:value="initvalue.promotionname"
                        placeholder="Promotion Name"
                        persistent-hint
                        single-line hint="Enter the promotion name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=promotiontype
                        :value="initvalue.promotiontype"
                        outlined
                        dense
                        v-on:change="onChangePromotion($event, 'promotiontype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the promotion type">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="['New', 'Active', 'Inactive']"
                        :value="initvalue.promotionstatus"
                        outlined
                        dense
                        v-on:change="onChangePromotion($event, 'promotionstatus')"
                        placeholder="Status"
                        persistent-hint
                        single-line hint="Please choose the status">
                      </v-select>

                    </v-form>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-menu
                          ref="menu_promotiondate"
                          v-model="menu_promotiondate"
                          :close-on-content-click="false"
                          :return-value.sync="promotion.promotiondate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-on:change="onChangePromotion($event, 'promotiondate')"
                              v-model="promotiondate"
                              v-bind:value="promotiondate"
                              label="Promotion Date"
                              v-bind="attrs"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line hint="Please enter promotion date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="promotiondate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_promotiondate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="onChangePromotion(promotiondate,'promotiondate');$refs.menu_promotiondate.save(promotiondate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          ref="menu_promotionstartdate"
                          v-model="menu_promotionstartdate"
                          :close-on-content-click="false"
                          :return-value.sync="promotionstartdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-on:change="onChangePromotion($event, 'promotionstartdate')"
                              v-model="promotionstartdate"
                              v-bind:value="promotionstartdate"
                              label="Start Date"
                              v-bind="attrs"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line hint="Please choose the start date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="promotionstartdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_promotionstartdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="onChangePromotion(promotionstartdate,'promotionstartdate');$refs.menu_promotionstartdate.save(promotionstartdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          ref="menu_promotionenddate"
                          v-model="menu_promotionenddate"
                          :close-on-content-click="false"
                          :return-value.sync="promotionenddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-on:change="onChangePromotion($event, 'promotionenddate')"
                              v-model="promotionenddate"
                              v-bind:value="promotionenddate"
                              label="End Date"
                              v-bind="attrs"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line hint="Please choose the end date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="promotionenddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_promotionenddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="onChangePromotion(promotionenddate,'promotionenddate');$refs.menu_promotionenddate.save(promotionenddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="5">
                    <div class="d-flex justify-center">
                        <v-btn
                            to="/promotion/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPromotion()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-photo'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>

                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload Photo</p>
                        <v-file-input label="File input" v-on:change="onChangePhotoFile" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="photourl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/promotion/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPromotionPhoto()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-bundles'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="11">
                        <p class="text-h5">Promotion Bundle</p>
                      </v-col>
                      <v-col md="1">
                        <v-btn
                          class="button-shadow"
                          color="secondary"
                          @click="isAddBundle = true"
                        >
                          Add
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="bundlerank"
                        :headers="bundleHeaders"
                        :items="promotionbundles"
                        :items-per-page="500"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteBundle" width="500">
                            <v-card>
                              <v-card-title> Delete this Bundle? </v-card-title>
                              <v-card-text>
                                {{ delete_bundle.bundlename }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteBundle = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deletePromotionBundle(delete_bundle)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>                    
                        <template v-slot:item.buyItemid="{ item }">
                          <p class="two-line" v-if="item.buyItemid!=undefined">{{ item.buyQty }} x {{ items.length>0 ? items.find(x=>x._id == item.buyItemid)['itemname'] : '' }}</p>
                        </template>
                        <template v-slot:item.getItemid="{ item }">
                          <p class="two-line" v-if="item.getItemid!=undefined">{{ item.getQty }} x {{ items.length>0 ? items.find(x=>x._id == item.getItemid)['itemname'] : '' }}</p>
                        </template>
                        <template v-slot:item.getSubcategoryid="{ item }">
                          <p class="two-line" v-if="item.getSubcategoryid!=undefined">{{ itemsubcategories.length>0 ? itemsubcategories.find(x=>x._id == item.getSubcategoryid)['itemsubcategoryname'] : '' }}</p>
                        </template>
                        <template v-slot:item.buyThreshold="{ item }">
                          <p class="two-line">{{ item.buyThreshold }}</p>
                          <p class="two-line">{{ item.getLimit }}</p>
                        </template>
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editPromotionBundleDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deletePromotionBundleDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/promotion/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-discounts'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="11">
                        <p class="text-h5">Promotion Discounts</p>
                      </v-col>
                      <v-col md="1">
                        <v-btn
                          class="button-shadow"
                          color="secondary"
                          @click="isAddDiscount = true"
                        >
                          Add
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="discountrank"
                        :headers="discountHeaders"
                        :items="promotiondiscounts"
                        :items-per-page="500"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteDiscount" width="500">
                            <v-card>
                              <v-card-title> Delete this Discount? </v-card-title>
                              <v-card-text>
                                {{ delete_bundle.discountname }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteDiscount = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deletePromotionDiscount(delete_discount)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.buyItemid="{ item }">
                          <p class="two-line" v-if="item.buyItemid!=undefined">{{ item.buyQty }} x {{ items.length>0 ? items.find(x=>x._id == item.buyItemid)['itemname'] : '' }}</p>
                        </template>
                        <template v-slot:item.discounttype="{ item }">
                          <p class="two-line">{{ item.discountvalue }} {{ item.discounttype }}</p>
                        </template>                   
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editPromotionDiscountDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deletePromotionDiscountDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/promotion/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-details'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="11">
                        <p class="text-h5">Promotion Details</p>
                      </v-col>
                      <v-col md="1">
                        <v-btn
                          class="button-shadow"
                          color="secondary"
                          @click="isAddDetail=true;"
                        >
                          Add
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="detailrank"
                        :headers="detailHeaders"
                        :items="promotiondetails"
                        :items-per-page="500"
                        :footer-props="footer"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteDetail" width="500">
                            <v-card>
                              <v-card-title> Delete this Detail? </v-card-title>
                              <v-card-text>
                                {{ delete_detail.detailrank }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteDetail = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deletePromotionDetail(delete_detail)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.detailbody="{ item }">
                          <p class="two-line" v-html="item.detailbody"></p>
                          <img v-if="item.detailimage" v-bind:src="item.detailimage" alt="" width="800px">
                        </template>                        
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editPromotionDetailDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deletePromotionDetailDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/promotion/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="isAddBundle"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Bundle</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="add_bundle.bundlerank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="10">
                <v-text-field
                  v-model="add_bundle.bundledesc"
                  label="Description"
                  single-line
                  hint="Description"
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1">
                <div>Buy</div>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="add_bundle.buyQty"
                  class="mb-4"
                  placeholder="Buy Qty"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Buy Qty"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="7">
                <v-select
                  class="mb-4"
                  :items="items.filter(x=>x.itemtype=='Item').map(x => {
                    return {text: x.itemname, value: x._id};
                  })"
                  v-model="add_bundle.buyItemid"
                  :value="add_bundle.buyItemid"
                  placeholder="Buy Item"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="add_bundle.buyThreshold"
                  class="mb-4"
                  placeholder="Threshold"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Threshold"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="1">
                <div>Get</div>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="add_bundle.getQty"
                  class="mb-4"
                  placeholder="Get Qty"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Get Qty"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="7">
                <v-select
                  class="mb-4"
                  :items="items.map(x => {
                    return {text: x.itemname, value: x._id};
                  })"
                  v-model="add_bundle.getItemid"
                  :value="add_bundle.getItemid"
                  placeholder="Get Item"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="add_bundle.getLimit"
                  class="mb-4"
                  placeholder="Limit"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Limit"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <div>Get Subcategory Group</div>
              </v-col>
              <v-col cols="12" md="7">
                <v-select
                  class="mb-4"
                  :items="[
                    {text: 'None', value: null},
                    ...itemsubcategories.map(x => {return {text: x.itemsubcategoryname, value: x._id}})
                  ]"
                  v-model="add_bundle.getSubcategoryid"
                  :value="add_bundle.getSubcategoryid"
                  placeholder="Get Group"
                  dense
                >
                </v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddBundle=false; add_bundle={}"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addPromotionBundleRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isAddDiscount"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Discount</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="add_discount.discountrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="10">
                <v-text-field
                  v-model="add_discount.discountdesc"
                  label="Description"
                  single-line
                  hint="Description"
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1">
                <div>Buy</div>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="add_discount.buyQty"
                  class="mb-4"
                  placeholder="Buy Qty"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Buy Qty"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="7">
                <v-select
                  class="mb-4"
                  :items="items.map(x => {
                    return {text: x.itemname, value: x._id};
                  })"
                  v-on:change="onChangeDiscount($event, 'buyItemid')"
                  v-model="add_discount.buyItemid"
                  :value="add_discount.buyItemid"
                  placeholder="Buy Item"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="add_discount.buyLimit"
                  class="mb-4"
                  placeholder="Limit"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Quanity Limit"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="1">
                <div>Get</div>
              </v-col>
              <v-col cols="12" md="5">
                <v-select
                  class="mb-4"
                  :items="['Percentage', 'Amount']"
                  v-model="add_discount.discounttype"
                  dense
                  placeholder="Discount Type"
                  single-line hint="Discount Type">
                </v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="add_discount.discountvalue"
                  class="mb-4"
                  placeholder="Discount"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Discount Amount"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="add_discount.getLimit"
                  class="mb-4"
                  placeholder="Limit"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Value Limit"
                  dense
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddDiscount=false; add_discount={}"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addPromotionDiscountRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="isAddDetail"
        persistent
        width="800px"
        max-width="800px"
      >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Detail</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-model="add_detail.detailrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line
                  dense
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="10">
                <v-file-input outlined dense label="File input" v-on:change="onChangeDetailFile" accept="image/*" />     
              </v-col>
              <v-col cols="12" md="12">
                 <vue-editor v-model="add_detail.detailbody"></vue-editor>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddDetail = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addPromotionDetailRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <v-row>
    <v-dialog
      v-model="isEditBundle"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Bundle</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="onChangeBundle($event, 'bundlerank')"
                  :value="edit_bundle.bundlerank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="10">
                <v-text-field
                  v-on:change="onChangeBundle($event, 'bundledesc')"
                  :value="edit_bundle.bundledesc"
                  label="Description"
                  single-line
                  hint="Description"
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1">
                <div>Buy</div>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="onChangeBundle($event, 'buyQty')"
                  :value="edit_bundle.buyQty"
                  class="mb-4"
                  placeholder="Buy Qty"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Buy Qty"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="7">
                <v-select
                  class="mb-4"
                  :items="items.filter(x=>x.itemtype=='Item').map(x => {
                    return {text: x.itemname, value: x._id};
                  })"
                  v-on:change="onChangeBundle($event, 'buyItemid')"
                  :value="edit_bundle.buyItemid"
                  placeholder="Buy Item"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="onChangeBundle($event, 'buyThreshold')"
                  :value="edit_bundle.buyThreshold"
                  class="mb-4"
                  placeholder="Threshold"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Threshold"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="1">
                <div>Get</div>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="onChangeBundle($event, 'getQty')"
                  :value="edit_bundle.getQty"
                  class="mb-4"
                  placeholder="Get Qty"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Get Qty"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="7">
                <v-select
                  class="mb-4"
                  :items="items.map(x => {
                    return {text: x.itemname, value: x._id};
                  })"
                  v-on:change="onChangeBundle($event, 'getItemid')"
                  :value="edit_bundle.getItemid"
                  placeholder="Get Item"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="onChangeBundle($event, 'getLimit')"
                  :value="edit_bundle.getLimit"
                  class="mb-4"
                  placeholder="Limit"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Limit"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <div>Get Subcategory Group</div>
              </v-col>
              <v-col cols="12" md="7">
                <v-select
                  class="mb-4"
                  :items="[
                    {text: 'None', value: null},
                    ...itemsubcategories.map(x => {return {text: x.itemsubcategoryname, value: x._id}})
                  ]"
                  v-on:change="onChangeBundle($event, 'getSubcategoryid')"
                  :value="edit_bundle.getSubcategoryid"
                  placeholder="Get Group"
                  dense
                >
                </v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditBundle = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editPromotionBundleRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isEditDiscount"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Discount</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="onChangeDiscount($event, 'discountrank')"
                  :value="edit_discount.discountrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="10">
                <v-text-field
                  v-on:change="onChangeDiscount($event, 'discountdesc')"
                  :value="edit_discount.discountdesc"
                  label="Description"
                  single-line
                  hint="Description"
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1">
                <div>Buy</div>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="onChangeDiscount($event, 'buyQty')"
                  :value="edit_discount.buyQty"
                  class="mb-4"
                  placeholder="Buy Qty"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Buy Qty"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="7">
                <v-select
                  class="mb-4"
                  :items="items.filter(x=>x.itemtype=='Item').map(x => {
                    return {text: x.itemname, value: x._id};
                  })"
                  v-on:change="onChangeDiscount($event, 'buyItemid')"
                  :value="edit_discount.buyItemid"
                  placeholder="Buy Item"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="onChangeDiscount($event, 'buyLimit')"
                  :value="edit_discount.buyLimit"
                  class="mb-4"
                  placeholder="Limit"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Quanity Limit"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="1">
                <div>Get</div>
              </v-col>
              <v-col cols="12" md="5">
                <v-select
                  class="mb-4"
                  :items="['Percentage', 'Amount']"
                  v-on:change="onChangeDiscount($event, 'discounttype')"
                  :value="edit_discount.discounttype"
                  dense
                  placeholder="Discount Type"
                  single-line hint="Discount Type">
                </v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-on:change="onChangeDiscount($event, 'discountvalue')"
                  :value="edit_discount.discountvalue"
                  class="mb-4"
                  placeholder="Discount"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Discount Amount"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-on:change="onChangeDiscount($event, 'getLimit')"
                  :value="edit_discount.getLimit"
                  class="mb-4"
                  placeholder="Limit"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Value Limit"
                  dense
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditDiscount = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editPromotionDiscountRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="isEditDetail"
        persistent
        width="800px"
        max-width="800px"
      >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Detail</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="onChangeDetail($event, 'detailrank')"
                  :value="edit_detail.detailrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 1) this.value = 1;"
                  single-line
                  hint="Num"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="8">
                <v-file-input outlined dense label="File input" v-on:change="onChangeDetailFile2" accept="image/*" />     
              </v-col>
              <v-col cols="12" md="12">
                 <vue-editor
                  v-model="htmltext"
                  @text-change="onChangeDetail(htmltext, 'detailbody')"
                  :value="edit_detail.detailbody"
                 ></vue-editor>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditDetail = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editPromotionDetailRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import {VueEditor} from "vue2-editor";
import {mapActions, mapState} from "vuex";
import {formatStdDate} from '@/mixins/date';
import router from '@/Routes';

export default {
  components: {
    VueEditor
  },
  data () {
    return {
      detailHeaders: [
        { text: "#", value: "detailrank", width: "10px", align: 'start'},
        { text: "Detail", value: "detailbody" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false, width: "10%" },
      ],
      bundleHeaders: [
        { text: "#", value: "bundlerank", width: "10px" },
        { text: "Desc", value: "bundledesc" },
        { text: "Buy", value: "buyItemid" },
        { text: "Get", value: "getItemid" },
        { text: "Group", value: "getSubcategoryid" },
        { text: "Threshold-Limit", value: "buyThreshold" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      discountHeaders: [
        { text: "#", value: "discountrank", width: "10px" },
        { text: "Desc", value: "discountdesc" },
        { text: "Buy", value: "buyItemid" },
        { text: "Qty Limit", value: "buyLimit" },
        { text: "Get", value: "discounttype" },
        { text: "Get Limit", value: "getLimit" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      initvalue: {},
      promotion: {},
      promotionbundles: [],
      promotiondiscounts: [],
      promotiondetails: [],
      promotiontype: ['Bundle', 'Discount'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
      add_bundle: {},
      add_discount: {},
      add_detail: {},
      edit_bundle: {},
      edit_discount: {},
      edit_detail: {},
      edit_photo: {},
      change_promotion: {},
      change_bundle: {},
      change_discount: {},
      change_detail: {},
      delete_bundle: {},
      delete_discount: {},
      delete_detail: {},
      isDeleteBundle: false,
      isDeleteDiscount: false,
      isDeleteDetail: false,
      isAddBundle: false,
      isAddDiscount: false,
      isAddDetail: false,
      isEditBundle: false,
      isEditDiscount: false,
      isEditDetail: false,
      menu_promotiondate: false,
      menu_promotionstartdate: false,
      menu_promotionenddate: false,
      promotiondate: null,
      promotionstartdate: null,
      promotionenddate: null,
      htmltext: null,
      photourl: null,
    }
  },
  computed: {
    ...mapState('Item', ['items']),
    ...mapState('ItemSubcategory', ['itemsubcategories']),
    ...mapState('Promotion', ['isReceiving'])
  },
  async created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({name: 'PromotionList'});
    this.photourl = this.initvalue.promotionimage;
    this.promotionbundles = this.initvalue.bundles;
    this.promotiondiscounts = this.initvalue.discounts;
    this.promotiondetails = this.initvalue.details;
    
    this.promotiondate = formatStdDate(this.initvalue.promotiondate);
    this.promotionstartdate = formatStdDate(this.initvalue.promotionstartdate);
    this.promotionenddate = formatStdDate(this.initvalue.promotionenddate);

    if(this.items.length==0) await this.getItemsRequest();
    if(this.itemsubcategories.length==0) await this.getItemSubcategoriesRequest();
  },
  methods: {
    ...mapActions('Item', ['getItemsRequest']),
    ...mapActions('ItemSubcategory', ['getItemSubcategoriesRequest']),
    ...mapActions('Promotion', 
    [ 
      'deletePromotionBundleRequest', 'deletePromotionDiscountRequest', 'deletePromotionDetailRequest',
      'insertPromotionBundleRequest', 'insertPromotionDiscountRequest', 'insertPromotionDetailRequest',
      'updatePromotionRequest','updatePromotionImageRequest','updatePromotionBundleRequest','updatePromotionDiscountRequest','updatePromotionDetailRequest' 
    ]),
    async addPromotionBundleRequest() {
      this.isAddBundle = false;
      this.add_bundle.promotionid = this.initvalue._id;
      let result = await this.insertPromotionBundleRequest(this.add_bundle);
      this.promotionbundles.push(result);
      this.add_bundle = {};
    },
    async addPromotionDiscountRequest() {
      this.isAddDiscount = false;
      this.add_discount.promotionid = this.initvalue._id;
      let result = await this.insertPromotionDiscountRequest(this.add_discount);
      this.promotiondiscounts.push(result);
      this.add_discount = {};
    },
    async addPromotionDetailRequest() {
      this.isAddDetail = false;
      this.add_detail.promotionid = this.initvalue._id;
      console.log(this.add_detail)
      let result = await this.insertPromotionDetailRequest(this.add_detail);
      this.promotiondetails.push(result);
      this.add_detail = {};
    },
    deletePromotionBundleDialog(item) {
      this.isDeleteBundle = true;
      this.delete_bundle = {
        _id: item._id,
        bundlename: item.bundlename,
      };
    },
    deletePromotionDiscountDialog(item) {
      this.isDeleteDiscount = true;
      this.delete_discount = {
        _id: item._id,
        discountname: item.discountname,
      };
    },
    deletePromotionDetailDialog(item) {
      this.isDeleteDetail = true;
      this.delete_detail = {
        _id: item._id,
        detailrank: item.detailrank,
      };
    },
    async deletePromotionBundle(payload) {
      this.isDeleteBundle = false;
      let response = await this.deletePromotionBundleRequest(payload);
      let index = this.promotionbundles.findIndex((trans) => trans._id == response._id);
      this.promotionbundles.splice(index, 1);
    },
    async deletePromotionDiscount(payload) {
      this.isDeleteDiscount = false;
      let response = await this.deletePromotionDiscountRequest(payload);
      let index = this.promotiondiscounts.findIndex((trans) => trans._id == response._id);
      this.promotiondiscounts.splice(index, 1);
    },
    async deletePromotionDetail(payload) {
      this.isDeleteDetail = false;
      let response = await this.deletePromotionDetailRequest(payload);
      let index = this.promotiondetails.findIndex((trans) => trans._id == response._id);
      this.promotiondetails.splice(index, 1);
    },
    async editPromotion() {
      this.change_promotion._id = this.initvalue._id;
      console.log(this.change_promotion);
      await this.updatePromotionRequest(this.change_promotion);
      router.push('/promotion/list');
    },
    async editPromotionPhoto() {
      this.edit_photo._id = this.initvalue._id;
      await this.updatePromotionImageRequest(this.edit_photo);
      router.push('/promotion/list');
    },
    editPromotionBundleDialog(item) {
      this.edit_bundle = Object.assign({}, item);
      this.change_bundle = {};
      this.isEditBundle = true;
    },
    editPromotionDiscountDialog(item) {
      this.edit_discount = Object.assign({}, item);
      this.change_discount = {};
      this.isEditDiscount = true;
    },
    editPromotionDetailDialog(item) {
      this.htmltext = item.detailbody;
      this.edit_detail = Object.assign({}, item);
      this.change_edit = {};
      this.isEditDetail = true;
    },
    async editPromotionBundleRequest() {
      this.isEditBundle = false;
      this.change_bundle.promotionbundleid = this.edit_bundle._id;
      let response = await this.updatePromotionBundleRequest(this.change_bundle);
      let index = this.promotionbundles.findIndex((x) => x._id == response._id);
      this.promotionbundles.splice(index, 1, response);
      this.edit_bundle = {};
      this.change_bundle = {};
    },
    async editPromotionDiscountRequest() {
      this.isEditDiscount = false;
      this.change_discount.promotiondiscountid = this.edit_discount._id;
      let response = await this.updatePromotionDiscountRequest(this.change_discount);
      let index = this.promotiondiscounts.findIndex((x) => x._id == response._id);
      this.promotiondiscounts.splice(index, 1, response);
    },
    async editPromotionDetailRequest() {
      this.isEditDetail = false;
      this.change_detail.promotiondetailid = this.edit_detail._id;
      let response = await this.updatePromotionDetailRequest(this.change_detail);
      let index = this.promotiondetails.findIndex((x) => x._id == response._id);
      this.promotiondetails.splice(index, 1, response);
    }, 
    onChangePromotion(value, field){
      this.change_promotion[field] = value;
    },      
    onChangeBundle(value, field){
      this.change_bundle[field] = value;
    },
    onChangeDiscount(value, field){
      this.change_discount[field] = value;
    },
    onChangeDetail(value, field){
      this.change_detail[field] = value;
    },
    onChangeDetailFile(file) {
      if (!file) {return;}
      this.add_detail.imagefile = file;
      this.add_detail.imagename = file.name;
    },
    onChangeDetailFile2(file) {
      if (!file) {return;}
      this.edit_detail.imagefile = file;
      this.edit_detail.imagename = file.name;
    },
    onChangePhotoFile(file) {
      if (!file) {return;}
      this.edit_photo.imagefile = file;
      this.edit_photo.imagename = file.name;
      this.createImage(file);
    }, 
    createImage(file) {
      const reader = new FileReader();
      reader.onload = e => {this.photourl = e.target.result;};
      reader.readAsDataURL(file);
    },
      
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
